import { forkify } from '@/shared/lib/core/fork';
import handleApiError from '@/shared/api/handleApiError';

export const jsonStringify = forkify((fork, args) => {
  try {
    const [object] = args;
    const string = JSON.stringify(object);
    fork.resolve(string);
  } catch (e) {
    fork.reject(e);
    handleApiError(e);
  }
});

export const jsonParse = forkify((fork, args) => {
  try {
    const [string] = args;
    const object = JSON.parse(string);
    fork.resolve(object);
  } catch (e) {
    fork.reject(e);
    handleApiError(e);
  }
});
